module.exports = __webpack_public_path__ + "img/Title.de4f7b34.png";